import type { FC } from 'react';

import { Each } from '@wwe-portal/ui/components/utils';
import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import type { PlayerRosterForClubStore } from '@wwe-portal/entities/roster.type';

import { PlayerCardDesktop, PlayerCardMobile } from '../roster-card';

interface BodyProps {
  data?: PlayerRosterForClubStore[];
  loading?: boolean;
  hasUpgradeIcon?: boolean;
  onItemClick: (id: string) => void;
}

export const BodyList: FC<BodyProps> = ({
  data,
  onItemClick,
  loading,
  hasUpgradeIcon,
}) => {
  return (
    <div className="flex w-full flex-col flex-wrap justify-start gap-y-[10px]">
      {data && !loading && (
        <Each
          data={data}
          render={(player) => (
            <div className="h-20 w-full" key={player.id}>
              <PlayerCardMobile
                data={player}
                hasUpgradeIcon={hasUpgradeIcon}
                onClick={() => onItemClick(player.id)}
              />
            </div>
          )}
        />
      )}
      {loading && (
        <Each
          data={new Array(4).fill(0)}
          render={(_, index) => (
            <Skeleton key={index} className="h-20 w-full" />
          )}
        />
      )}
    </div>
  );
};

export const BodyGrid: FC<BodyProps> = ({
  data: playerRosterList,
  loading,
  onItemClick,
}) => {
  return (
    <div className="3xl:grid-cols-5 grid grid-cols-3 gap-[30px]">
      {playerRosterList && !loading && (
        <Each
          data={playerRosterList}
          render={(player) => (
            <div className="h-[408px] w-full" key={player.id}>
              <PlayerCardDesktop
                data={player}
                onClick={() => onItemClick(player.id)}
              />
            </div>
          )}
        />
      )}

      {loading && (
        <Each
          data={new Array(15).fill(0)}
          render={(_, index) => (
            <Skeleton key={index} className="h-[408px] w-full" />
          )}
        />
      )}
    </div>
  );
};
